import React, { useMemo } from "react";
import styled, { css } from "styled-components";
import take from "lodash/take";
import last from "lodash/last";
const RestTypesContainer = styled.i(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.small};
    display: block;
    margin-top: 5px;
  `
);
export const useColumnRenderers = (fieldTypes) => {
  const customColumnRenderers = useMemo(
    () => ({
      attributes: {
        stream_titles: {
          renderCell: (streams) => streams.join(", ")
        },
        types: {
          renderCell: (items) => {
            const latest = fieldTypes[last(items)] || last(items);
            const rest = take(items, items.length - 1).map((item) => fieldTypes[item] || item);
            if (!latest) return /* @__PURE__ */ React.createElement("i", null, "type is not defined");
            return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, latest)), !!rest.length && /* @__PURE__ */ React.createElement(RestTypesContainer, null, "(previous values: ", rest.join(", "), ")"));
          },
          staticWidth: 220
        }
      }
    }),
    [fieldTypes]
  );
  return customColumnRenderers;
};
export default useColumnRenderers;
